module.exports = __webpack_public_path__ + "img/fight2.efeec3c0.svg";